module.exports = __webpack_public_path__ + "static/media/kangyang-4@2x.0612d42c.png";